import React from 'react';
import { motion } from 'framer-motion';
import { bookInfoRo } from '../../../data/bookDataRo';

const AuthorHeroRo = () => (
  <section 
    className="relative min-h-[60vh] flex items-center pt-28 pb-16 overflow-hidden bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url('https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2Uvd2VicA==/f0f1d05f4c645121bb31be39eed2bf1c.webp')` }}
  >
    <div className="absolute inset-0 z-0 bg-black/60"></div>
    <div className="absolute inset-0 z-0 bg-gradient-to-b from-brand-dark/90 via-transparent to-brand-dark"></div>
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-accent/10 blur-[150px] rounded-full z-0"></div>

    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10 w-full">
      <div className="flex flex-col md:flex-row items-center gap-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }} 
          animate={{ opacity: 1, scale: 1 }} 
          transition={{ duration: 0.7 }} 
          className="flex-shrink-0"
        >
          <div className="w-48 h-48 md:w-64 md:h-64 rounded-2xl overflow-hidden border-2 border-brand-accent/30 shadow-2xl shadow-brand-accent/10 relative group">
            <div className="absolute inset-0 bg-brand-accent/10 mix-blend-overlay group-hover:bg-transparent transition-colors duration-500 z-10"></div>
            <img 
              src={bookInfoRo.authorImage} 
              alt={bookInfoRo.author} 
              className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700" 
            />
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.2 }} 
          className="text-center md:text-left"
        >
          <p className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-3 drop-shadow-md">
            Despre Autor
          </p>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-white mb-4 text-glow">
            {bookInfoRo.author}
          </h1>
          <p className="text-gray-200 text-lg max-w-xl drop-shadow-md">
            Creatorul universului expansiv al <em className="text-white">Trezirii Cuantice</em> — o viziune panoramică asupra viitorului umanității de-a lungul a cinci secole și al sistemului solar.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);

export default AuthorHeroRo;